export const FIRST_PAGE = 1;
export const DISPLAYED_PAGES_QUANTITY = 5;
export const NUM_INDEXABLE_PAGES = 10;



// WEBPACK FOOTER //
// ./app/Serp/components/shared/Pager/constants.js